import { images } from "../images";

export const businessProfileData = [
  {
    user: "type 01",
    data: {
      selectedServicesData: [
        "3D Visualization/Rendering",
        "Accessibility Consulting",
        "Accessibility Design",
        "Accessibility",
      ],
      selectedSupportData: ["Support 1", "Support 2", "Support 3", "Support 4"],
    },
  },
  {
    user: "type 02",
    data: {
      selectedServicesData: [
        "3D Visualization/Rendering",
        "Accessibility Consulting",
        "Accessibility Design",
        "Accessibility",
      ],

      selectedSupportData: ["Support 1", "Support 2", "Support 3", "Support 4"],

      servicesDropdownArr: [
        { value: "Service 01" },
        { value: "Service 02" },
        { value: "Service 03" },
        { value: "Service 04" },
        { value: "Service 05" },
      ],

      supportDropdownArr: [
        { value: "Support 01" },
        { value: "Support 02" },
        { value: "Support 03" },
        { value: "Support 04" },
        { value: "Support 05" },
      ],

      selectedEmployeeCountArr: ["Upto 10"],
      employeeCountArr: ["Upto 10", "10-20", "20-50", "50-100", "100+"],

      selectedPricingTrendArr: ["Medium"],
      pricingTrendArr: ["Low", "Medium", "High"],

      selectedProjectSizes: ["500-2000 sq.ft.", "2000 sq.ft. - 5000 sq.ft."],
      projectSizes: [
        "All",
        "500-2000 sq.ft.",
        "2000 sq.ft. - 5000 sq.ft.",
        "5000 sq.ft. - 10000 sq.ft.",
        "Above 10,000 sq.ft.",
      ],

      selectedLocationPref: ["In my country"],
      locationPref: ["Anywhere", "In my country", "In my city"],

      selectedProjectTypologyData: [
        "Typology 01",
        "Typology 02",
        "Typology 03",
      ],

      projectTypologyData: [
        { value: "Typology 01" },
        { value: "Typology 02" },
        { value: "Typology 03" },
        { value: "Typology 04" },
        { value: "Typology 05" },
      ],

      selectedDesignStyleData: [
        "Design Style 01",
        "Design Style 02",
        "Design Style 03",
      ],

      designStyleData: [
        { value: "Design Style 01" },
        { value: "Design Style 02" },
        { value: "Design Style 03" },
        { value: "Design Style 04" },
        { value: "Design Style 05" },
      ],

      selectedProjScopeData: [
        "Project Scope 01",
        "Project Scope 02",
        "Project Scope 03",
      ],

      projScopeData: [
        { value: "Project Scope 01" },
        { value: "Project Scope 02" },
        { value: "Project Scope 03" },
        { value: "Project Scope 04" },
        { value: "Project Scope 05" },
      ],

      selectedAvgBudgetData: ["1000 - 2500 Rs./ sq.ft."],
      avgBudgetData: [
        "Anything",
        "1000 - 2500 Rs./ sq.ft.",
        "2500-5000 Rs./ sq.ft.",
        "Above 5000 Rs./sft",
      ],

      selectedMinFeeData: ["5,00,000 - 10,00,000 INR"],
      minFeeData: [
        "0 - 1,00,000 INR",
        "1,00,000 - 5,00,000 INR",
        "5,00,000 - 10,00,000 INR",
        "Above 10,00,000 INR",
      ],

      completedGalleryArr: [
        images.projectGallery01.image,
        images.projectGallery01.image,
        images.projectGallery01.image,
        images.projectGallery01.image,
        images.projectGallery01.image,
      ],

      projectRendersArr: [
        images.projectGallery01.image,
        images.projectGallery01.image,
        images.projectGallery01.image,
        images.projectGallery01.image,
      ],

      wipSiteArr: [
        images.projectGallery01.image,
        images.projectGallery01.image,
        images.projectGallery01.image,
      ],

      otherMediaArr: [
        images.projectGallery01.image,
        images.projectGallery01.image,
      ],

      modalDataArr: [
        {
          description: [
            "Product Catalogues/Brochures",
            "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
            "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
          ],
        },
        {
          description: [
            "Completed Project Photos/Videos",
            "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
            "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
          ],
        },
        {
          description: [
            "Project Renders",
            "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
            "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
          ],
        },
        {
          description: [
            "Work In Progress - Site Photos/Videos",
            "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
            "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
          ],
        },
        {
          description: [
            "Other Media",
            "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
            "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
          ],
        },
        {
          description: [
            "Take Us Through Your Work Space",
            "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
            "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
          ],
        },
      ],

      companyProfilesData: [
        "arch_while_furthermore.tar",
        "speedily_amongst.abw,blizzard.wav",
        "calculating_whose.jpe,normal_psst.txt",
      ],

      galleryData: [
        images.projectGallery01.image,
        images.projectGallery01.image,
        images.projectGallery01.image,
        images.projectGallery01.image,
        images.projectGallery01.image,
        images.projectGallery01.image,
        images.projectGallery01.image,
        images.projectGallery01.image,
        images.projectGallery01.image,
        images.projectGallery01.image,
        images.projectGallery01.image,
        images.projectGallery01.image,
        images.projectGallery01.image,
        images.projectGallery01.image,
        images.projectGallery01.image,
        images.projectGallery01.image,
      ],

      workSpaceData: [
        { option: "ALL" },
        { option: "Adaptive Reuse" },
        { option: "Commercial" },
        { option: "Conservation" },
        { option: "Cultural" },
        { option: "Educational" },
        { option: "Environmental" },
        { option: "Healthcare" },
        { option: "Historical Restoration" },
        { option: "Hospitality" },
        { option: "Industrial" },
        { option: "Institutional" },
        { option: "Interior" },
        { option: "Landscape" },
        { option: "Mixed-Use" },
        { option: "Public Spaces" },
        { option: "Recreational" },
        { option: "Renovation" },
        { option: "Residential" },
        { option: "Retail" },
        { option: "Socially Responsive Design" },
        { option: "Sustainable" },
        { option: "Technology-Centric" },
        { option: "Urban Planning" },
        { option: "Workspace" },
        { option: "Exhibition Spaces" },
        { option: "Historical" },
        { option: "Vintage" },
      ],
    },
  },
];
